import { NOTIFY, REMOVE_NOTIFICATION, RESET } from './actionTypes'

export function reset() {
  return { 
    type : RESET
  }
}


export function notify( notification ) {
  console.log('Notifications - Action notify')
  
  if ( notification.popup ) return null;

  return (dispatch, getState) => {

    dispatch( {
      type: NOTIFY,
      notification
    } )

    setTimeout(() => {
      dispatch({
        type: REMOVE_NOTIFICATION,
        notification
      })
    }, 10000);
    
  }
}

export function runActionHandler( notification ) {
  return (dispatch, getState) => {
    
    
    if ( notification.actionHandler && !notification.handled ) {

      notification.handled = true

      notification.actionHandler()

    }

    dispatch({
      type: REMOVE_NOTIFICATION,
      notification
    })

  }
}
  